import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import {
  setDefaults as setGeoCodeApiKey,
  fromPlaceId,
  fromAddress,
  fromLatLng,
} from "react-geocode";
import Map from "devextreme-react/map";
function GooglePlaceSearchComponent(props) {
  const [state, setState] = useState({
    location: {
      houseApartment: "",
      roadArea: "",
      landmark: "",
      address: "",
      cityName: "",
      stateName: "",
      countryName: "",
      postalCode: "",
      latitude: "",
      longitude: "",
    },
  });
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      if (
        props?.optionalAutoFillLatitude?.toString()?.trim() !== "" &&
        props?.optionalAutoFillLongitude?.toString()?.trim() !== ""
      ) {
        setTimeout(async () => {
          await getPlaseData(
            "LATLNG",
            "",
            props.optionalAutoFillLatitude,
            props.optionalAutoFillLongitude
          );
        }, 0);
      } else if (props?.optionalAutoFillAddress?.trim() !== "") {
        setTimeout(async () => {
          await getPlaseData("ADDRESS", props.optionalAutoFillAddress);
        }, 0);
      }
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  setGeoCodeApiKey({
    key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    language: "en",
    region: "es",
  });
  const getPlaseData = async (
    requestType,
    address,
    latitude,
    longitude,
    placeid
  ) => {
    try {
      let place;
      switch (requestType) {
        case "ADDRESS":
          place = await fromAddress(address);
          break;
        case "LATLNG":
          place = await fromLatLng(latitude, longitude);
          break;
        case "PLACE_ID":
          place = await fromPlaceId(placeid);
          break;
        default:
          break;
      }
      if (place?.results?.length > 0) {
        const { lat, lng } = place.results[0].geometry.location;
        const address = place.results[0].formatted_address;
        let {
          houseApartment,
          roadArea,
          landmark,
          cityName,
          stateName,
          countryName,
          postalCode,
        } = place.results[0].address_components.reduce((acc, component) => {
          if (component.types.includes("premise"))
            acc.houseApartment = component.long_name;
          else if (component.types.includes("route"))
            acc.roadArea = component.long_name;
          else if (component.types.includes("sublocality_level_1"))
            acc.landmark = component.long_name;
          else if (component.types.includes("locality"))
            acc.cityName = component.long_name;
          else if (component.types.includes("administrative_area_level_1"))
            acc.stateName = component.long_name;
          else if (component.types.includes("country"))
            acc.countryName = component.long_name;
          else if (component.types.includes("postal_code"))
            acc.postalCode = component.long_name;
          return acc;
        }, {});
        landmark = place.results[0]?.address_components
          .filter((addressComponent) =>
            addressComponent.types.find(
              (c) => c === "sublocality_level_1" || c === "sublocality_level_2"
            )
          )
          ?.map((a) => a.long_name)
          ?.join(", ");

        setState((prev) => ({
          ...prev,
          location: {
            ...state.location,
            houseApartment: houseApartment,
            roadArea: roadArea,
            landmark: landmark,
            address: address,
            cityName: cityName,
            stateName: stateName,
            countryName: countryName,
            postalCode: postalCode,
            latitude: lat,
            longitude: lng,
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handelOnGooglePlaseChange = async (data) => {
    try {
      await getPlaseData("PLACE_ID", "", 0, 0, data.value.place_id);
      // let location = state.location;
      // location.address = data.label;
      // setState((prev) => ({
      //   ...prev,
      //   location: location,
      // }));
      // const place = await fromPlaceId(data.value.place_id);
      // const { lat, lng } = place.results[0].geometry.location;
      // const address = data.label; //place.results[0].formatted_address;
      // // const postalCode = place.results[0]?.address_components.find(
      // //   (addressComponent) => addressComponent.types.includes("postal_code")
      // // )?.long_name;
      // const {
      //   cityName,
      //   stateName,
      //   countryName,
      //   postalCode,
      //   landmark,
      //   addressTitle,
      // } = place.results[0].address_components.reduce((acc, component) => {
      //   if (component.types.includes("locality"))
      //     acc.cityName = component.long_name;
      //   else if (component.types.includes("administrative_area_level_1"))
      //     acc.stateName = component.long_name;
      //   else if (component.types.includes("country"))
      //     acc.countryName = component.long_name;
      //   else if (component.types.includes("postal_code"))
      //     acc.postalCode = component.long_name;
      //   else if (component.types.includes("sublocality_level_1"))
      //     acc.landmark = component.long_name;
      //   else if (component.types.includes("premise"))
      //     acc.addressTitle = component.long_name;
      //   return acc;
      // }, {});
      // setState((prev) => ({
      //   ...prev,
      //   location: {
      //     ...state.location,
      //     addressTitle: addressTitle,
      //     landmark: landmark,
      //     address: address,
      //     cityName: cityName,
      //     stateName: stateName,
      //     countryName: countryName,
      //     postalCode: postalCode,
      //     latitude: lat,
      //     longitude: lng,
      //   },
      // }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            <i className="fab fa-google fa-lg" style={{ color: "red" }} />
            {"  "}Search address
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <GooglePlacesAutocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                  height={35}
                  options={{
                    types: ["address"],
                  }}
                  selectProps={{
                    autoFocus: true,
                    isClearable: true,
                    isSearchable: true,
                    defaultInputValue: state.location.address,
                    onChange: async (data) => {
                      await handelOnGooglePlaseChange(data);
                    },
                    placeholder: "Search address",
                    styles: {
                      input: (provided) => ({
                        ...provided,
                        color: "black",
                      }),
                      option: (provided) => ({
                        ...provided,
                        color: "black",
                        background: "#00000000",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        // color: "blue",
                        // background:"black"
                      }),
                      control: (provided) => ({
                        ...provided,
                        width: "100%",
                        background: "rgba(255, 255, 255, 0.25)",
                        border: "1px solid rgba(255, 255, 255, 0.41)",
                        backdropFilter: "blur(50px)",
                        borderRadius: "12px",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: "100%",
                        background: "rgba(255, 255, 255, 0.25)",
                        border: "1px solid rgba(255, 255, 255, 0.41)",
                        backdropFilter: "blur(50px)",
                        borderRadius: "12px",
                      }),
                      container: (provided) => ({
                        ...provided,
                        marginTop: "5px",
                      }),
                    },
                    //isMulti: true,
                  }}
                  debounce={200}
                />
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div
                style={{
                  height: `350px`,
                  width: `100%`,
                }}
              >
                <Map
                  defaultZoom={16}
                  height="100%"
                  width="100%"
                  controls={true}
                  onClick={async (e) => {
                    let location = state.location;
                    const { lat, lng } = e.location;
                    try {
                      if (lat > 0 && lng > 0) {
                        location.latitude = lat;
                        location.longitude = lng;
                        let place = await fromLatLng(lat, lng);
                        if (place?.results?.length > 0) {
                          location.address = place.results[0].formatted_address;
                          setState((prev) => ({
                            ...prev,
                            location: location,
                          }));
                        }
                      }
                    } catch (error) {}
                  }}
                  markerIconSrc="https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png"
                  markers={[
                    {
                      location: [
                        state.location.latitude,
                        state.location.longitude,
                      ],
                      tooltip: {
                        text: state.location.address,
                      },
                    },
                  ]}
                  provider="google"
                  apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                ></Map>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Accept"
            className="btn btn-success"
            onClick={() => {
              props.onChange(state.location);
              props.onClose();
            }}
          >
            <i className={`fas fa-check`} />
            &nbsp;&nbsp;Accept
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-custom-gray"
            onClick={() => {
              props.onClose();
            }}
          >
            <span title="Reset">
              <i className="fas fa-times"></i>&nbsp; Close
            </span>
          </button>
        </div>
      </Modal>
    </div>
  );
}
export default GooglePlaceSearchComponent;
